import initREM from './init-rem';
import initELF from './init-elf';
import '../ubt';

/**
 * 这里是页面初始化时候需要做的配置
 */
export default async function (): Promise<void> {
  try {
    await initREM();
    await initELF();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return Promise.resolve();
}
